import { useSelector } from "react-redux";
import { getAppLoggedIn } from "../../modules/Auth/authSelectors.js";
import { Redirect } from "react-router-dom";
import { RouterPaths } from "../../app/appConstants";
import { generatePath } from "react-router";
import LandingPage from "../../modules/Landing/LandingPage.jsx";

function PageWelcome() {
    const isLoggedIn = useSelector(getAppLoggedIn);

    if (isLoggedIn) {
        return <Redirect to={generatePath(RouterPaths.overview)}/>;
    }

    return <LandingPage/>;
}

export default PageWelcome;
